
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11712',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11712",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.272",
  "data-fetching-client": "static-1.9529",
  "foundations-components": "static-1.7627",
  "foundations-components-legacy": "static-1.652",
  "foundations-theming": "static-1.4263",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7858",
  "hub-http-shared-msw-handlers": "static-1.9596",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11295",
  "I18n": "static-7.1586",
  "jasmine-runner": "static-1.6322",
  "marketplace-storefront-base": "static-1.11772",
  "quartz": "static-1.6803",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16502",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2715",
  "reporting-testing-lib": "static-1.8669",
  "settings-ui-lib": "static-1.12376",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6834",
  "ui-addon-i18n": "static-1.10996",
  "ui-addon-react-router-dom": "static-1.9397",
  "unified-auth": "static-1.288",
  "unified-auth-core-lib": "static-1.569",
  "usage-tracker": "static-1.7187",
  "usage-tracker-core": "static-1.7037",
  "customer-data-property-utils": "static-1.7932",
  "history": "static-4.47",
  "hub-http": "static-1.6070",
  "integrations-lib": "static-1.15586",
  "marketplace-ui-common": "static-1.19092",
  "property-management-iframe": "static-1.12554",
  "quartz-config": "static-1.581",
  "quartz-core": "static-1.6022",
  "quartz-routing": "static-1.233",
  "quick-fetch": "static-1.3786",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4493",
  "ts-schema": "static-1.3953",
  "ui-universal-auth": "static-1.8774",
  "UIComponents": "static-3.8242",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3278",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3080",
  "quartz-webpack": "static-1.3027",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3896",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4694",
  "foundations-theming-specialty": "static-1.1979",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9278",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5222",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1356",
  "ui-fonts": "static-1.557",
  "ui-images": "static-2.1111",
  "bend-plugin-foundations-theming": "static-1.2746",
  "foundations-theming-base": "static-1.3248",
  "stylex": "static-1.28",
  "HeadJS": "static-2.723",
  "hs-test-utils-bend-plugin": "static-1.2969",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4178",
  "ai-components-ui-library": "static-1.8499",
  "ai-rendering-library": "static-1.9468",
  "chirp-fetch": "static-1.1735",
  "connections-embed-lib": "static-1.713",
  "copilot-toolkit": "static-1.10666",
  "laboratory-lib": "static-3.7011",
  "marketplace-embed": "static-1.21607",
  "marketplace-ui-details": "static-1.8988",
  "marketplace-ui-reviews": "static-1.19048",
  "marketplace-ui-tracking": "static-1.13263",
  "sanitize-text": "static-1.7997",
  "ui-addon-video-player": "static-1.8548",
  "usage-tracker-multi": "static-1.5601",
  "usage-tracker-session-replay": "static-1.4873",
  "wootric-nps": "static-1.6834",
  "apollo-link-hub-http": "static-2.4503",
  "immer": "static-1.33",
  "immerable": "static-1.4006",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2397",
  "reporting-data": "static-1.66736",
  "cssUtils": "static-1.751",
  "flux-actions": "static-1.316",
  "HubStyle": "static-2.11603",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10063",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10226",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7177",
  "icons": "static-2.630",
  "marketplace-ui-apps-core": "static-1.17625",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4372",
  "foundations-components-test-utils": "static-1.5110",
  "quartz-i18n": "static-1.478",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3582",
  "customer-data-objects": "static-1.7503",
  "property-translator": "static-1.5262",
  "frontend-preferences-client": "static-1.7777",
  "hs-promise-utils": "static-1.5445",
  "hubspot-apollo-client": "static-1.4731",
  "integrations-error-boundary-lib": "static-1.13001",
  "integrations-tracking-lib": "static-1.5443",
  "native-integrations-shared-strings": "static-1.7639",
  "reselect": "static-2.16",
  "sanitize": "static-1.4326",
  "superstore": "static-1.4621",
  "ui-shepherd-react": "static-3.9998",
  "ai-settings-ui-library": "static-1.7616",
  "hub-http-janus": "static-1.808",
  "hubspotter-http": "static-1.4526",
  "immutable-less": "static-1.4506",
  "marketplace-ui-client-types": "static-1.16499",
  "nav-meta": "static-1.29076",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10094",
  "ui-addon-upgrades": "static-9.17734",
  "inbound-db-properties-service-client": "static-1.3719",
  "property-management-common": "static-1.4841",
  "ui-addon-iframeable": "static-1.8899",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.498",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.478",
  "quartz-head": "static-1.468",
  "quartz-test": "static-1.478",
  "quartz-tracking": "static-1.182",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3005",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20544",
  "ContentUtils": "static-1.67779",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2345",
  "customer-data-filters-ui": "static-1.39085",
  "customer-data-objects-ui-components": "static-1.12865",
  "customer-data-reference-ui-components": "static-1.13001",
  "embedded-academy-lib": "static-1.13736",
  "ExportDialog": "static-6.10240",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40787",
  "reporting-snowflake": "static-1.55354",
  "reporting-ui-components": "static-2.64007",
  "reporting-visualizations": "static-1.58812",
  "ui-addon-teams": "static-1.21314",
  "magpie-lib": "static-1.5446",
  "magpie-types": "static-1.4906",
  "simple-logging-lib": "static-1.2902",
  "navigation-components": "static-1.17439",
  "ai-studio-lib": "static-1.11135",
  "app-governance-lib": "static-1.1027",
  "developer-experience-shared-components": "static-1.10352",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7843",
  "ui-product-approvals": "static-1.27613",
  "ui-tool-access": "static-1.9996",
  "usage-based-billing-components-lib": "static-1.8151",
  "usage-tracker-anonymous": "static-1.5604",
  "usage-tracker-public": "static-1.6998",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3468",
  "persist-promise": "static-1.3560",
  "reference-resolvers": "static-1.8016",
  "ui-extensibility-client-types": "static-1.3793",
  "hubspot-apollo-cache": "static-1.190",
  "universal-page-editor-lib": "static-1.2854",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2321",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4922",
  "purchase-motions-components": "static-1.5560",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1403",
  "crm-component-utils": "static-1.38601",
  "crm-properties-common-lib": "static-1.5725",
  "customer-data-properties": "static-1.50935",
  "framework-data-schema-resolvers": "static-1.6726",
  "property-value-citations": "static-1.1549",
  "reference-resolvers-lite": "static-1.7937",
  "navigation-messaging": "static-1.6766",
  "hubspotter-http-shared-msw-handlers": "static-1.9594",
  "cms-field-types": "static-1.4661",
  "content-icons-ui": "static-1.2175",
  "conversations-skeleton-state": "static-1.7100",
  "crm-message-bus": "static-1.42517",
  "customer-data-filters-ui-msw-helpers": "static-1.21520",
  "customer-data-ui-utilities": "static-1.9676",
  "FormUrlGenerator": "static-2.4573",
  "framework-builder-read-service-client": "static-1.3881",
  "framework-data-schema-quick-fetch": "static-1.6631",
  "multi-account-reference-resolvers": "static-1.828",
  "onboarding-tours": "static-1.16339",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13204",
  "academy-common-lib": "static-1.13196",
  "content-assistance-lib": "static-1.7524",
  "dashboard-lib": "static-1.80838",
  "file-manager-components": "static-1.23053",
  "getting-started-shared-tasks": "static-1.18022",
  "hubspot-prosemirror": "static-1.17742",
  "hubspot-prosemirror-plugins": "static-1.17734",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19560",
  "share-with-third-party-component-lib": "static-1.8546",
  "ui-addon-draggable": "static-3.4619",
  "ui-asset-management-lib": "static-1.10782",
  "ui-business-units-lib": "static-1.8885",
  "user-context": "static-1.4952",
  "growth-payments-core": "static-1.24870",
  "reporting-plugins": "static-1.10045",
  "reporting-reports": "static-1.66414",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.577",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28969",
  "react-codemirror": "static-1.10478",
  "framework-listing-lib": "static-2-rr-react-compiler.25",
  "fuzzy": "static-1.8",
  "apps-service-types": "static-1.3730",
  "oauth-service-types": "static-1.4100",
  "onboarding-scopes": "static-1.6315",
  "onboarding-tours-client": "static-1.4553",
  "platform-infra-nav-components": "static-1.7540",
  "subscription-experience-data-types": "static-1.14653",
  "crm-record-cards-service-types": "static-1.3490",
  "location-customization-utils-lib": "static-1.8725",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4352",
  "nav-client-types": "static-1.2210",
  "purchase-motions-api": "static-1.5563",
  "signup-constants": "static-1.18514",
  "signup-ui-url-generator": "static-2.7887",
  "trials-service-types": "static-1.3753",
  "card-properties-lib": "static-1.43667",
  "commerce-subscription-lib": "static-1.36604",
  "crm-actions": "static-1.6160",
  "crm-cards-sdk": "static-1.43072",
  "customer-data-properties-shared-msw-handlers": "static-1.8923",
  "customer-data-tracking": "static-1.6734",
  "hs-entities": "static-1.537",
  "pulse": "static-1.376",
  "calling-global-api": "static-1.63874",
  "calling-internal-common": "static-1.31151",
  "calling-lifecycle-internal": "static-1.65256",
  "calling-lifecycle-messages": "static-1.57549",
  "commerce-products-lib": "static-1.8991",
  "conditional-properties-service-client": "static-1.3671",
  "crm-links": "static-1.6121",
  "external-options-client-types": "static-1.4032",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4096",
  "meetings-icalendar-utils-lib": "static-1.484",
  "multi-currency-client-types": "static-1.3564",
  "object-builder-ui-client": "static-1.48166",
  "pipeline-validation-client-types": "static-1.3837",
  "smart-property-lib": "static-1.6133",
  "tiered-pricing": "static-1.910",
  "ui-addon-form-validation": "static-1.10845",
  "crm-pipelines-api-client-types": "static-1.4013",
  "customer-data-associations": "static-1.7175",
  "customer-data-views-management": "static-1.25098",
  "framework-data-table": "static-2.11539",
  "marketing-platform-lib": "static-1.6697",
  "nudge-client-utils": "static-1.2267",
  "nudge-custom-ui-functions": "static-1.773",
  "react-dnd-compat": "static-1.4472",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5212",
  "growth-onboarding-confetti": "static-1.2924",
  "growth-onboarding-next-action-utils": "static-1.1429",
  "onboarding-tours-utils": "static-1.405",
  "ui-shepherd-tracker": "static-1.7379",
  "academy-service-client": "static-1.3533",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28079",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8235",
  "video-components-external": "static-1.10732",
  "video-data-lib": "static-1.34390",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8410",
  "payment-link-components": "static-1.23073",
  "ui-addon-emoji-picker": "static-1.9739",
  "EmailSignatureEditor": "static-1.23994",
  "viral-links-lib": "static-1.6891",
  "data-token-picker": "static-1.16131",
  "FileManagerLib": "static-1.38693",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5096",
  "getting-started-shared-tasks-store": "static-1.17140",
  "campaign-roi-lib": "static-1.8434",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.245",
  "eligibility-engine-service-types": "static-1.3034",
  "crm_data": "static-4.91413",
  "customer-data-sidebar": "static-2.45552",
  "enrichment-properties-lib": "static-1.15251",
  "commerce-billing-lib": "static-1.18631",
  "commerce-shared-components-lib": "static-1.18090",
  "commerce-tools-ui-lib": "static-1.9923",
  "crm-fe-perf": "static-1.22757",
  "directed-graph": "static-1.791",
  "event-emitter": "static-1.799",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31157",
  "shared-worker-versioning": "static-1.10891",
  "calling-usage-tracker": "static-1.6393",
  "voice-sms-access-library": "static-1.395",
  "commerce-permissions": "static-1.615",
  "products-iframe-lib": "static-1.7466",
  "products-ui-components-shared-msw-handlers": "static-1.9978",
  "breeze-intelligence-kit": "static-1.5398",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9679",
  "policy-lib": "static-1.6630",
  "react-tinymce": "static-1.54764",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9742",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53890",
  "tinymce-plugins": "static-1.57004",
  "tinymce-themes": "static-1.55860",
  "crm-export-dialog": "static-1.6145",
  "crm-index-associations-lib": "static-1.6287",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1448",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2024",
  "nudge-renderer-utils": "static-1.2343",
  "whisper-core-api": "static-1.6135",
  "InboxConnectUtils": "static-4.14355",
  "growth-onboarding-next-action-components": "static-1.1457",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6433",
  "content-media-composition-data-lib": "static-1.11657",
  "content-media-compositions": "static-2.15664",
  "media-bridge-lib": "static-1.18653",
  "commerce-tours-lib": "static-1.5801",
  "growth-onboarding-reliability": "static-1.4938",
  "sales-checkout-service-client": "static-1.3520",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21396",
  "sales-email-signature-service-client": "static-1.3696",
  "audio-components": "static-1.5688",
  "FileManagerCore": "static-1.38552",
  "FileManagerImages": "static-1.36204",
  "video-components": "static-1.12735",
  "crm_universal": "static-1.21748",
  "customer-data-email": "static-1.17758",
  "card-payment-highlight-lib": "static-1.36657",
  "card-subscription-highlight-lib": "static-1.39027",
  "commerce-contract-lib": "static-1.11383",
  "customer-data-content": "static-1.26969",
  "invoices-highlight-card-lib": "static-1.54192",
  "orders-highlight-card-lib": "static-1.20999",
  "products-highlight-card-lib": "static-1.17275",
  "project-storage": "static-1.4585",
  "quotes-highlight-card-lib": "static-1.71367",
  "crm-source-interpretation-lib": "static-1.5184",
  "utility-belt": "static-1.2392",
  "payments-enrollment-embed-lib": "static-1.22153",
  "customer-data-rte": "static-1.32568",
  "cv-backend-services": "static-1.1519",
  "growth-onboarding-empty-states": "static-1.5444",
  "payments-post-enroll-local-storage-lib": "static-1.4966",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37457",
  "calling-orchestration-schema": "static-1.35172",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2895",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39975",
  "ui-addon-sales-email": "static-1.5066",
  "layout-dnd-components": "static-1.12138",
  "layout-dnd-utils": "static-1.11113",
  "ui-brand-identity-lib": "static-1.14251",
  "NamespacedHubStyle": "static-2.8944",
  "deal-intel-utils": "static-1.1452",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4383",
  "video-embed": "static-1.35224",
  "social-insights-client-types": "static-1.21509",
  "sequences-lib": "static-1.7770",
  "ui-gdpr-components": "static-1.10200",
  "products-ui-components": "static-1.39510",
  "quotes-ui-lib": "static-1.80088",
  "SalesContentIndexUI": "static-3.8983",
  "accounting-integrations-ui-components": "static-1.6808",
  "invoices-ui-lib": "static-1.54208",
  "commerce-products-api": "static-1.2036",
  "SafeStorage": "static-1.4254",
  "invoices-iframe-lib": "static-1.56266",
  "quotes-modal-lib": "static-1.102045",
  "stripe-embedded-components": "static-1.7226",
  "draft-content-plugins": "static-1.27837",
  "ContentData": "static-1.67854",
  "layout-data-lib": "static-1.9438",
  "outpost": "static-1.4052",
  "sequences-client-types-lib": "static-1.7627",
  "commerce-tax-lib": "static-1.370",
  "property-description-translator": "static-1.3708",
  "FireAlarmUi": "static-1.4381",
  "sales-templates-service-types-lib": "static-1.4040",
  "commerce-analytics-service-client": "static-1.3508",
  "totals-ui-components": "static-1.23125",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14893",
  "advanced-menus-lib": "static-1.11862",
  "ui-memberships-settings-lib": "static-1.33585",
  "commerce-totals-service-types": "static-1.3689",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14892",
  "simple-menus-lib": "static-1.16409"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11712",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.272",
  "data-fetching-client": "/data-fetching-client/static-1.9529",
  "foundations-components": "/foundations-components/static-1.7627",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.652",
  "foundations-theming": "/foundations-theming/static-1.4263",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7858",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9596",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11295",
  "I18n": "/I18n/static-7.1586",
  "jasmine-runner": "/jasmine-runner/static-1.6322",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11772",
  "quartz": "/quartz/static-1.6803",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16502",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2715",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8669",
  "settings-ui-lib": "/settings-ui-lib/static-1.12376",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6834",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10996",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9397",
  "unified-auth": "/unified-auth/static-1.288",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.569",
  "usage-tracker": "/usage-tracker/static-1.7187",
  "usage-tracker-core": "/usage-tracker-core/static-1.7037",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7932",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6070",
  "integrations-lib": "/integrations-lib/static-1.15586",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19092",
  "property-management-iframe": "/property-management-iframe/static-1.12554",
  "quartz-config": "/quartz-config/static-1.581",
  "quartz-core": "/quartz-core/static-1.6022",
  "quartz-routing": "/quartz-routing/static-1.233",
  "quick-fetch": "/quick-fetch/static-1.3786",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4493",
  "ts-schema": "/ts-schema/static-1.3953",
  "ui-universal-auth": "/ui-universal-auth/static-1.8774",
  "UIComponents": "/UIComponents/static-3.8242",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3278",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3080",
  "quartz-webpack": "/quartz-webpack/static-1.3027",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3896",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4694",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1979",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9278",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5222",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1356",
  "ui-fonts": "/ui-fonts/static-1.557",
  "ui-images": "/ui-images/static-2.1111",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2746",
  "foundations-theming-base": "/foundations-theming-base/static-1.3248",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.723",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2969",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4178",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8499",
  "ai-rendering-library": "/ai-rendering-library/static-1.9468",
  "chirp-fetch": "/chirp-fetch/static-1.1735",
  "connections-embed-lib": "/connections-embed-lib/static-1.713",
  "copilot-toolkit": "/copilot-toolkit/static-1.10666",
  "laboratory-lib": "/laboratory-lib/static-3.7011",
  "marketplace-embed": "/marketplace-embed/static-1.21607",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8988",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19048",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13263",
  "sanitize-text": "/sanitize-text/static-1.7997",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8548",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5601",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4873",
  "wootric-nps": "/wootric-nps/static-1.6834",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4503",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4006",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2397",
  "reporting-data": "/reporting-data/static-1.66736",
  "cssUtils": "/cssUtils/static-1.751",
  "flux-actions": "/flux-actions/static-1.316",
  "HubStyle": "/HubStyle/static-2.11603",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10063",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10226",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7177",
  "icons": "/icons/static-2.630",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17625",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4372",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5110",
  "quartz-i18n": "/quartz-i18n/static-1.478",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3582",
  "customer-data-objects": "/customer-data-objects/static-1.7503",
  "property-translator": "/property-translator/static-1.5262",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7777",
  "hs-promise-utils": "/hs-promise-utils/static-1.5445",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4731",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13001",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5443",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7639",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4326",
  "superstore": "/superstore/static-1.4621",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9998",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7616",
  "hub-http-janus": "/hub-http-janus/static-1.808",
  "hubspotter-http": "/hubspotter-http/static-1.4526",
  "immutable-less": "/immutable-less/static-1.4506",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16499",
  "nav-meta": "/nav-meta/static-1.29076",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10094",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17734",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3719",
  "property-management-common": "/property-management-common/static-1.4841",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8899",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.498",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.478",
  "quartz-head": "/quartz-head/static-1.468",
  "quartz-test": "/quartz-test/static-1.478",
  "quartz-tracking": "/quartz-tracking/static-1.182",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3005",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20544",
  "ContentUtils": "/ContentUtils/static-1.67779",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2345",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39085",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12865",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13001",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13736",
  "ExportDialog": "/ExportDialog/static-6.10240",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40787",
  "reporting-snowflake": "/reporting-snowflake/static-1.55354",
  "reporting-ui-components": "/reporting-ui-components/static-2.64007",
  "reporting-visualizations": "/reporting-visualizations/static-1.58812",
  "ui-addon-teams": "/ui-addon-teams/static-1.21314",
  "magpie-lib": "/magpie-lib/static-1.5446",
  "magpie-types": "/magpie-types/static-1.4906",
  "simple-logging-lib": "/simple-logging-lib/static-1.2902",
  "navigation-components": "/navigation-components/static-1.17439",
  "ai-studio-lib": "/ai-studio-lib/static-1.11135",
  "app-governance-lib": "/app-governance-lib/static-1.1027",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10352",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7843",
  "ui-product-approvals": "/ui-product-approvals/static-1.27613",
  "ui-tool-access": "/ui-tool-access/static-1.9996",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8151",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5604",
  "usage-tracker-public": "/usage-tracker-public/static-1.6998",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3468",
  "persist-promise": "/persist-promise/static-1.3560",
  "reference-resolvers": "/reference-resolvers/static-1.8016",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3793",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.190",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2854",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2321",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4922",
  "purchase-motions-components": "/purchase-motions-components/static-1.5560",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1403",
  "crm-component-utils": "/crm-component-utils/static-1.38601",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5725",
  "customer-data-properties": "/customer-data-properties/static-1.50935",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6726",
  "property-value-citations": "/property-value-citations/static-1.1549",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7937",
  "navigation-messaging": "/navigation-messaging/static-1.6766",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9594",
  "cms-field-types": "/cms-field-types/static-1.4661",
  "content-icons-ui": "/content-icons-ui/static-1.2175",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7100",
  "crm-message-bus": "/crm-message-bus/static-1.42517",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21520",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9676",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4573",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3881",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6631",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.828",
  "onboarding-tours": "/onboarding-tours/static-1.16339",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13204",
  "academy-common-lib": "/academy-common-lib/static-1.13196",
  "content-assistance-lib": "/content-assistance-lib/static-1.7524",
  "dashboard-lib": "/dashboard-lib/static-1.80838",
  "file-manager-components": "/file-manager-components/static-1.23053",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18022",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17742",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17734",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19560",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8546",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4619",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10782",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8885",
  "user-context": "/user-context/static-1.4952",
  "growth-payments-core": "/growth-payments-core/static-1.24870",
  "reporting-plugins": "/reporting-plugins/static-1.10045",
  "reporting-reports": "/reporting-reports/static-1.66414",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.577",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28969",
  "react-codemirror": "/react-codemirror/static-1.10478",
  "framework-listing-lib": "/framework-listing-lib/static-2-rr-react-compiler.25",
  "fuzzy": "/fuzzy/static-1.8",
  "apps-service-types": "/apps-service-types/static-1.3730",
  "oauth-service-types": "/oauth-service-types/static-1.4100",
  "onboarding-scopes": "/onboarding-scopes/static-1.6315",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4553",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7540",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14653",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3490",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8725",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4352",
  "nav-client-types": "/nav-client-types/static-1.2210",
  "purchase-motions-api": "/purchase-motions-api/static-1.5563",
  "signup-constants": "/signup-constants/static-1.18514",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7887",
  "trials-service-types": "/trials-service-types/static-1.3753",
  "card-properties-lib": "/card-properties-lib/static-1.43667",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36604",
  "crm-actions": "/crm-actions/static-1.6160",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43072",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8923",
  "customer-data-tracking": "/customer-data-tracking/static-1.6734",
  "hs-entities": "/hs-entities/static-1.537",
  "pulse": "/pulse/static-1.376",
  "calling-global-api": "/calling-global-api/static-1.63874",
  "calling-internal-common": "/calling-internal-common/static-1.31151",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65256",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57549",
  "commerce-products-lib": "/commerce-products-lib/static-1.8991",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3671",
  "crm-links": "/crm-links/static-1.6121",
  "external-options-client-types": "/external-options-client-types/static-1.4032",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4096",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.484",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3564",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48166",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3837",
  "smart-property-lib": "/smart-property-lib/static-1.6133",
  "tiered-pricing": "/tiered-pricing/static-1.910",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10845",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4013",
  "customer-data-associations": "/customer-data-associations/static-1.7175",
  "customer-data-views-management": "/customer-data-views-management/static-1.25098",
  "framework-data-table": "/framework-data-table/static-2.11539",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6697",
  "nudge-client-utils": "/nudge-client-utils/static-1.2267",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.773",
  "react-dnd-compat": "/react-dnd-compat/static-1.4472",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5212",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2924",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1429",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.405",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7379",
  "academy-service-client": "/academy-service-client/static-1.3533",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28079",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8235",
  "video-components-external": "/video-components-external/static-1.10732",
  "video-data-lib": "/video-data-lib/static-1.34390",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8410",
  "payment-link-components": "/payment-link-components/static-1.23073",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9739",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23994",
  "viral-links-lib": "/viral-links-lib/static-1.6891",
  "data-token-picker": "/data-token-picker/static-1.16131",
  "FileManagerLib": "/FileManagerLib/static-1.38693",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5096",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17140",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8434",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.245",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3034",
  "crm_data": "/crm_data/static-4.91413",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45552",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15251",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18631",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18090",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9923",
  "crm-fe-perf": "/crm-fe-perf/static-1.22757",
  "directed-graph": "/directed-graph/static-1.791",
  "event-emitter": "/event-emitter/static-1.799",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31157",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10891",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6393",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.395",
  "commerce-permissions": "/commerce-permissions/static-1.615",
  "products-iframe-lib": "/products-iframe-lib/static-1.7466",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9978",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5398",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9679",
  "policy-lib": "/policy-lib/static-1.6630",
  "react-tinymce": "/react-tinymce/static-1.54764",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9742",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53890",
  "tinymce-plugins": "/tinymce-plugins/static-1.57004",
  "tinymce-themes": "/tinymce-themes/static-1.55860",
  "crm-export-dialog": "/crm-export-dialog/static-1.6145",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6287",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1448",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2024",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2343",
  "whisper-core-api": "/whisper-core-api/static-1.6135",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14355",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1457",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6433",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11657",
  "content-media-compositions": "/content-media-compositions/static-2.15664",
  "media-bridge-lib": "/media-bridge-lib/static-1.18653",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5801",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4938",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3520",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21396",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3696",
  "audio-components": "/audio-components/static-1.5688",
  "FileManagerCore": "/FileManagerCore/static-1.38552",
  "FileManagerImages": "/FileManagerImages/static-1.36204",
  "video-components": "/video-components/static-1.12735",
  "crm_universal": "/crm_universal/static-1.21748",
  "customer-data-email": "/customer-data-email/static-1.17758",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36657",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39027",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11383",
  "customer-data-content": "/customer-data-content/static-1.26969",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54192",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20999",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17275",
  "project-storage": "/project-storage/static-1.4585",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71367",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5184",
  "utility-belt": "/utility-belt/static-1.2392",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22153",
  "customer-data-rte": "/customer-data-rte/static-1.32568",
  "cv-backend-services": "/cv-backend-services/static-1.1519",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5444",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4966",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37457",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35172",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2895",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39975",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5066",
  "layout-dnd-components": "/layout-dnd-components/static-1.12138",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11113",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14251",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8944",
  "deal-intel-utils": "/deal-intel-utils/static-1.1452",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4383",
  "video-embed": "/video-embed/static-1.35224",
  "social-insights-client-types": "/social-insights-client-types/static-1.21509",
  "sequences-lib": "/sequences-lib/static-1.7770",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10200",
  "products-ui-components": "/products-ui-components/static-1.39510",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80088",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8983",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6808",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54208",
  "commerce-products-api": "/commerce-products-api/static-1.2036",
  "SafeStorage": "/SafeStorage/static-1.4254",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56266",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102045",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7226",
  "draft-content-plugins": "/draft-content-plugins/static-1.27837",
  "ContentData": "/ContentData/static-1.67854",
  "layout-data-lib": "/layout-data-lib/static-1.9438",
  "outpost": "/outpost/static-1.4052",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7627",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.370",
  "property-description-translator": "/property-description-translator/static-1.3708",
  "FireAlarmUi": "/FireAlarmUi/static-1.4381",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4040",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3508",
  "totals-ui-components": "/totals-ui-components/static-1.23125",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14893",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11862",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33585",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3689",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14892",
  "simple-menus-lib": "/simple-menus-lib/static-1.16409"
}
};
